var App = App || {};

App.RateDetailsAccordions = (function ($) {
    'use strict';

    function init() {

        /* SMOOTH SCROLL FOR ANCHOR LINKS */

        $(document).on("click", "a.anchored-nav-item", function (e) {
            if (this.pathname !== window.location.pathname) {
                return;
            }

            if (!this.hash) {
                return;
            }

            e.preventDefault();

            var $target = $(this.hash);

            if ($target.length) {
                $("html, body").animate({
                    scrollTop: $target.offset().top
                }, 200, "linear");
            }
        });
        /* MOBILE NAVIGATION */

        const mobileToggle =
            document.querySelector(".mobile-nav-toggle");

        const accordion =
            document.querySelector(".custom-accordion");

        const toggleText =
            mobileToggle?.querySelector(".toggle-text");

        if (mobileToggle && accordion) {

            mobileToggle.addEventListener("click", function () {

                const isExpanded =
                    mobileToggle.getAttribute("aria-expanded") === "true";

                mobileToggle.setAttribute(
                    "aria-expanded",
                    !isExpanded
                );
                accordion.classList.toggle("mobile-open");

                mobileToggle.classList.toggle("active");

                toggleText.textContent = !isExpanded
                    ? "Close Rates Navigation"
                    : "Open Rates Navigation";
            });
        }

    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.RateDetailsAccordions.init();
});